import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full py-12 px-4 bg-base" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-alt border border-primary/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-129">
          {/* Soft glow behind shield */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-48 bg-primary/10 rounded-full blur-3xl pointer-events-none" data-id="element-130" />

          <div className="relative z-10" data-id="element-131">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary/10 mb-6 border border-primary/20" data-id="element-132">
              <Shield size={40} className="text-primary" data-id="element-133" />
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-text-main mb-8" data-id="element-134">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="space-y-4 text-lg text-text-muted max-w-xl mx-auto mb-8" data-id="element-135">
              <p data-id="element-136">Abrís los tomos. Los usás en tu negocio.</p>
              <p data-id="element-137">Si en 7 días no es lo que esperabas:</p>

              <div className="bg-base rounded-xl p-6 border border-alt text-left mt-6" data-id="element-138">
                <p className="flex items-center gap-3 text-text-main font-medium mb-3" data-id="element-139">
                  <span className="text-primary" data-id="element-140">→</span> Devolución del 100%
                </p>
                <p className="flex items-center gap-3 text-text-main font-medium" data-id="element-141">
                  <span className="text-primary" data-id="element-142">→</span> Sin formularios. Sin
                  drama. Sin explicaciones.
                </p>
              </div>
            </div>

            <p className="text-sm font-bold text-primary tracking-wider uppercase" data-id="element-143">
              Tasa de devoluciones: menos del 1%
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}